export default __webpack_public_path__ + "static/media/ex-sign.6c1a04ed.svg";